// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fe6608ee","498":"5d6b77b6","545":"d4978638"}[chunkId] + ".chunk.js";
};